import React, { useContext, useEffect, useRef } from 'react';
import { Navigate, Route, Routes, useLocation } from 'react-router-dom';
import PerfectScrollbar from "perfect-scrollbar";
import { AppContext } from '../AppContext';

import Navbar from '../components/Navbars/Navbar';
import Footer from '../components/Footer/Footer';
import Sidebar from '../components/Sidebar/Sidebar';

import routes from "../routes/index";

const DefaultLayout = (props) => {
  const userData = JSON.parse(localStorage.getItem('userData'));
//   console.log({userData});

  const mainPanel = useRef();
  const location = useLocation();

  useEffect(() => {
    if (navigator.platform.indexOf("Win") > -1 && mainPanel.current) {
      const ps = new PerfectScrollbar(mainPanel.current);
      document.body.classList.toggle("perfect-scrollbar-on");

      return () => {
        if (ps) {
          ps.destroy();
        }
        document.body.classList.toggle("perfect-scrollbar-on");
      };
    }
  }, []);

  useEffect(() => {
    if (mainPanel.current) {
      mainPanel.current.scrollTop = 0;
      document.scrollingElement.scrollTop = 0;
    }
  }, [location]);

  if (!localStorage.getItem('token')) {
    return <Navigate to="/login" />;
  }

  const filteredRoutes = routes.filter((route) => {
    if (userData?.type === 'ADMIN') {
      return route.role === 'superAdmin';
    } else {
      return route.role === 'user';
    }
  });

//   console.log(filteredRoutes, 'filteredRoutes');

  return (
    <div className="wrapper">
      <Sidebar
        {...props}
        routes={filteredRoutes}
        bgColor='black'
        activeColor='warning'
      />
      <div className="main-panel" ref={mainPanel}>
        <Navbar {...props} />
        <Routes>
          {filteredRoutes.map((prop, key) => {
			// check sub routes
			if (prop.hasOwnProperty('sub_routes') && prop.sub_routes.length > 0) {
				return prop.sub_routes.map((subProp, subKey) => {
					return (
						<Route
							path={subProp.path}
							element={subProp.component}
							key={`${key}-${subKey}`}
							exact
						/>
					);
				});
			}
			
            return (
              <Route
                path={prop.path}
                element={prop.component}
                key={key}
                exact
              />
            );
          })}
        </Routes>
        <Footer fluid />
      </div>
    </div>
  );
}

export default DefaultLayout;
